import React from 'react';
import { RadioGroup, FormControlLabel, Radio, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import styles from './RadioGroupwithDelete.module.css';

const RadioGroupWithDelete = ({ options, selectedOption, onChange, handleDeletion }) => {

  return (
    <RadioGroup className={styles.group} value={selectedOption} onChange={(e) => onChange(e.target.value)}>
      {options.map((option) => (
        <div key={option} className={styles.item}>
            <FormControlLabel
              value={option}
              control={<Radio />}
              label={option}
              className={styles.label}
            />

            {option !== 'List All' && (
              <div className={styles.deleteIconWrap}>
                <IconButton onClick={() => handleDeletion(option)}>
                  <DeleteIcon color='primary' />
                </IconButton>
              </div>)}
        </div>

      ))}
    </RadioGroup>
  );
};

export default RadioGroupWithDelete;